export default __webpack_public_path__ + "static/media/emoji2.5f5383cf.svg";